export default function cloneObject<T>(obj: T): T {
  return obj ? JSON.parse(JSON.stringify(obj)) : obj
}
